export default __webpack_public_path__ + "static/media/logo-glik.b3b5ab9c.png";